import { useEffect, useState } from "react";
import { Button, Carousel, Col, Container, Modal, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import axios from "axios";
import { API_ENDPOINTS } from '../../../../config/api';


const Home = () => {
  const [events, setEvents] = useState([]);
  const [eventSlides, setEventSlides] = useState([]);
  const [eventDetails, setEventDetails] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showHelpModal, setShowHelpModal] = useState(false);

  useEffect(() => {
    const hasSeenHelp = localStorage.getItem("seenHelpPopup");
    if (!hasSeenHelp) {
      setShowHelpModal(true);
      localStorage.setItem("seenHelpPopup", "true");
    }
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.EVENTS.GET_ALL);
        const fetchedEvents = response.data;
        setEvents(fetchedEvents);

        // Group events into slides of 3 per slide
        const grouped = [];
        for (let i = 0; i < fetchedEvents.length; i += 3) {
          grouped.push(fetchedEvents.slice(i, i + 3));
        }
        setEventSlides(grouped);

        // Create a simple event details object
        const detailMap = {};
        fetchedEvents.forEach(event => {
          detailMap[event.title] = {
            startDate: event.startDate,
            endDate: event.endDate,
            description: event.description || "No description available.",
            location: event.location
          };
        });
        setEventDetails(detailMap);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % eventSlides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + eventSlides.length) % eventSlides.length);

  useEffect(() => {
    const handleClickOutside = () => setSelectedEvent(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className="main-content">
      <Container className="mt-4" style={{ maxWidth: '1200px' }}>
      <Modal show={showHelpModal} onHide={() => setShowHelpModal(false)} centered backdrop="static">
        <div className="db1-modal-header">
          <h5 className="mb-0" style={{ color: '#a70a4a' }}>Welcome Volunteer!</h5>
          <button onClick={() => setShowHelpModal(false)} className="btn-close" style={{ color: '#a70a4a' }}></button>
        </div>
        <div className="db1-modal-content">
          <ul>
            <li><strong>Profile:</strong> Edit your personal details and view your <strong>User ID</strong>.</li>
            <li><strong>Home:</strong> View <strong>TMGF Moments</strong> and highlighted events.</li>
            <li><strong>Event:</strong> Participate in ongoing/upcoming/completed events.</li>
            <li><strong>Event Initiatives:</strong> Create your own events and track approval status.</li>
          </ul>
          <p style={{ color: '#7f8c9b' }}>Return to Help section anytime from sidebar.</p>
        </div>
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid rgba(0,0,0,0.04)', display: 'flex', justifyContent: 'flex-end' }}>
          <button className="db1-export-btn" style={{ background: '#ac2e62', color: 'white' }} onClick={() => setShowHelpModal(false)}>OK</button>
        </div>
      </Modal>

      <div className="db1-glass-card" style={{ padding: '30px', marginTop: '20px' }}>
        <div className="text-center mb-4">
          <img src="/images/LOGO.png" alt="TMGF Logo" style={{ width: "120px" }} />
          <h2 style={{ fontWeight: "bold", marginTop: 10, marginBottom: 20 }}>
            <span style={{ color: "#ac2e62" }}>The Mother Global Foundation</span>
          </h2>
          <p style={{ color: "#2c3e50", fontWeight: 500 }}>
            Founder: Padma Shri Dr. Sindhutai Sapkal 'Maai'
          </p>
          <p className="mt-2" style={{ color: '#7f8c9b', maxWidth: "80%", margin: "0 auto" }}>
            We are an NGO focused on uplifting and empowering orphaned children and destitutes through orphanages,
            support, and education.
          </p>
        </div>

        <Container>
          <Row className="g-4">
            <Col xs={12} md={6}>
              <div className="db1-glass-card" style={{ padding: '16px' }}>
                <h5 className="text-center fw-bold mb-3" style={{ color: '#2c3e50' }}>Our Moments</h5>
                <Carousel controls={false} indicators={false} interval={2500}>
                  {["/images/homeImg1.jpg", "/images/homeImg2.jpg", "/images/homeImg3.jpg", "/images/homeImg4.jpg"].map((src, i) => (
                    <Carousel.Item key={i}>
                      <img
                        src={src}
                        alt={`Moment ${i + 1}`}
                        className="d-block w-100 img-fluid"
                        style={{ height: "240px", objectFit: "cover", borderRadius: "8px" }}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>

            <Col xs={12} md={6}>
              <div className="db1-glass-card" style={{ padding: '16px', position: "relative" }}>
                <h5 className="text-center fw-bold mb-3" style={{ color: '#2c3e50' }}>Our Events</h5>
                <div>
                  {eventSlides[currentSlide]?.map((event, index) => (
                    <div
                      key={index}
                      className="p-2 my-1 rounded"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedEvent(event.title);
                      }}
                      style={{ borderLeft: '4px solid #ac2e62', background: 'rgba(172,46,98,0.02)', cursor: "pointer", marginBottom: '6px' }}
                    >
                      <div style={{display : "flex", justifyContent : 'space-between'}}>
                        <h6 className="fw-bold mb-1" style={{ color: "#ac2e62", fontSize: '0.9rem' }}>{event.title}</h6>
                        <span style={{ color: '#7f8c9b', fontStyle: 'italic', fontSize: '0.8rem' }}>{event.status}</span>
                      </div>
                      <p className="mb-0" style={{ fontSize: "0.82rem", color: '#2c3e50' }}>{event.description}</p>
                    </div>
                  ))}
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <button onClick={prevSlide} className="db1-nav-btn"><FaArrowLeft /></button>
                  <button onClick={nextSlide} className="db1-nav-btn"><FaArrowRight /></button>
                </div>

                {selectedEvent && eventDetails[selectedEvent] && (
                  <div
                    className="position-absolute p-3 rounded shadow"
                    style={{
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 999,
                      background: 'rgba(255,255,255,0.95)',
                      backdropFilter: 'blur(12px)',
                      border: '1px solid rgba(172,46,98,0.2)',
                      borderRadius: '16px',
                      width: "300px"
                    }}
                  >
                    <h5 className="fw-bold text-center mb-2" style={{ color: "#ac2e62" }}>{selectedEvent}</h5>
                    <p style={{ color: '#2c3e50', fontSize: '0.85rem' }}><strong>Start Date:</strong> {eventDetails[selectedEvent].startDate}</p>
                    <p style={{ color: '#2c3e50', fontSize: '0.85rem' }}><strong>End Date:</strong> {eventDetails[selectedEvent].endDate}</p>
                    <p style={{ color: '#2c3e50', fontSize: '0.85rem' }}><strong>Description:</strong> {eventDetails[selectedEvent].description}</p>
                    <p style={{ color: '#2c3e50', fontSize: '0.85rem' }}><strong>Location:</strong> {eventDetails[selectedEvent].location}</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      </Container>
    </div>
  );
};

export default Home;
